<script>
import { makeLogger } from "@/shared/consola";
const logger = makeLogger("CoffeeCreator.vue");
</script>

<script setup>
import vCreator from "@/shared/views/vCreator.vue";
import cCreatorStep from "@/shared/components/creator/cCreatorStep.vue";
import cCreatorThemes from "@/shared/components/creator/cCreatorThemes.vue";
import cCreatorProduct from "@/shared/components/creator/cCreatorProduct.vue";
import { ButtonPrimarySm } from "@easy/ui/buttons";
import { RocketIcon } from "@easy/ui/icons";
import { computed } from "vue";
import { useCoffeeCreatorStore } from "@/apps/coffee/project/onboarding/coffee-creator.store";
import { isColorDark } from "@/shared/utils/helpers";
import { storeToRefs } from "pinia";
import { useOnboardingVideo } from "@/shared/projects/onboarding/useOnboardingVideos";

// const { locale } = useI18n();
const { video } = useOnboardingVideo("coffee");
const coffeeCreatorStore = useCoffeeCreatorStore();
const { onboardState, previewCssVars, previewComponent } = storeToRefs(coffeeCreatorStore);
const { updateProductInfo, toggleCreatorShown, onboardingAction } = coffeeCreatorStore;

const backgroundColor = computed(() =>
    isColorDark(onboardState.value.theme?.colors?.background) ? "#f9fafb" : "#17171C"
);

const buttonTextColor = computed(
    () => onboardState.value.theme?.colors?.background
    //isColorDark(onboardState.value.theme?.colors?.brand) ? "#ffffff" : "#000000"
);

const generateOnboarding = onboardingAction();
logger.trace("instance created");
</script>

<template>
    <vCreator
        :backColor="backgroundColor"
        :canSkipGenerator="!onboardState.isLoading"
        :description="$t('coffee.creator.subtitle')"
        :title="$t('coffee.creator.title')"
        :video="video"
        @close="toggleCreatorShown(false)"
    >
        <cCreatorStep
            :title="
                onboardState.showProductPickerOnly
                    ? $t('shared.creator.step_data_source_title_no_prompt')
                    : $t('shared.creator.step_data_source_title')
            "
            :description="
                onboardState.showProductPickerOnly
                    ? $t('shared.creator.step_data_source_description_no_prompt')
                    : $t('shared.creator.step_data_source_description')
            "
            :step="1"
        >
            <cCreatorProduct
                :error="onboardState.error"
                :hidePrompt="onboardState.hidePrompt"
                :showProductPickerOnly="onboardState.showProductPickerOnly"
                v-model:productSelectLater="onboardState.productSelectLater"
                @productInfoUpdated="updateProductInfo($event)"
            />
        </cCreatorStep>
        <cCreatorStep
            :title="$t('coffee.creator.step_theme_title')"
            :description="$t('coffee.creator.step_theme_description')"
            :step="2"
        >
            <cCreatorThemes v-model="onboardState.theme" />
        </cCreatorStep>
        <cCreatorStep
            :title="$t('coffee.creator.step_final_title')"
            :description="$t('coffee.creator.step_final_description')"
            :step="3"
            :last="true"
        >
            <ButtonPrimarySm @click="generateOnboarding()" :loading="onboardState.isLoading">
                <RocketIcon />
                <span>{{ $t("coffee.creator.step_final_cta") }} </span>
            </ButtonPrimarySm>
        </cCreatorStep>
        <template #preview>
            <div :style="{ ...previewCssVars }">
                <component :is="previewComponent" :buttonTextColor="buttonTextColor" />
            </div>
        </template>
    </vCreator>
</template>
